// test1480
(1480 && 0);
